import { createSelector } from 'reselect'

const getState = state => state.payouts

export const getPayoutsList = createSelector(getState, ({ payouts }) => payouts)
export const getAwaitingPayoutsList = createSelector(
  getState,
  ({ awaitingPayouts }) => awaitingPayouts
)
export const getPaidPayoutsList = createSelector(
  getState,
  ({ paidPayouts }) => paidPayouts
)
export const getPayoutsCounters = createSelector(
  getState,
  ({ payoutsCount }) => payoutsCount
)
export const getTotalBalance = createSelector(
  getState,
  ({ totalBalance }) => totalBalance
)
export const sendRecipientCheckingNeeded = createSelector(
  getState,
  ({ sent }) => sent
)
